<template>
  <div id="content" class="my-account">
    <div class="container">
      <div class="row">
        <div
          class="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-6 cd-user-modal"
        >
          <div class="my-account-form">
            <ul class="cd-switcher" style="padding-left: 0px">
              <li><a class="selected" href="#0">CONNEXION</a></li>
              <li><a href="#0" class="">INSCRIPTION</a></li>
            </ul>

            <div id="cd-login" class="is-selected">
              <Login :nextUrl="nextUrl" />
            </div>

            <div id="cd-signup" class="">
              <Register :nextUrl="nextUrl" />
            </div>

            <div class="page-login-form" id="cd-reset-password">
              <p class="cd-form-message">
                Vous avez oublié votre mot de passe? Veuillez saisir votre
                adresse email. Vous recevrez un lien pour créer un nouveau mot
                de passe.
              </p>
              <ResetPasswordForm :nextUrl="nextUrl" />
              <p class="cd-form-bottom-message">
                <a href="#0">Revenir à la connexion</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/MyAccount/Login";
import Register from "@/components/MyAccount/Register";
import ResetPasswordForm from "@/components/MyAccount/ResetPasswordForm";
export default {
  name: "MyAccountContent",
  props: {
    nextUrl: String,
  },
  components: { ResetPasswordForm, Register, Login },
};
</script>

<style scoped></style>
